'use client'; // This component uses Framer Motion

import React from 'react';
import { motion } from 'framer-motion';

// Wrapper component for Framer Motion animations
const ClientMotionCard = ({ children }: { children: React.ReactNode }) => {
  return (
    <motion.div
      className="group relative bg-gray-800 rounded-lg overflow-hidden shadow-lg transition-all duration-300 ease-in-out h-full flex flex-col cursor-pointer"
      whileHover={{
        scale: 1.03,
        boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.4)', // Enhanced shadow on hover
      }}
      transition={{ duration: 0.2, ease: 'easeInOut' }}
    >
      {children}
    </motion.div>
  );
};

export default ClientMotionCard;
